import {
    CircularProgress,
} from '@mui/material'
import noop from 'lodash/noop'

import useStyles from './Button.style'

type Props = {
    className?: string
    classNameLabel?: string
    label: string
    onClick: (...args: any[]) => void
    secondary?: boolean
    alert?: boolean
    disabled?: boolean
    saving?: boolean
    icon?: JSX.Element | null
    isUpperCase?: boolean
    name?: string
}

const defaultProps: Partial<Props> = {
    className: '',
    classNameLabel: undefined,
    secondary: false,
    disabled: false,
    alert: undefined,
    saving: false,
    icon: null,
    isUpperCase: true,
    name: undefined,
}

const Button = ({
    label,
    onClick,
    secondary,
    disabled,
    alert,
    saving,
    icon,
    className,
    classNameLabel,
    isUpperCase,
}: Readonly<Props>) => {
    const {
        classes,
        cx,
    } = useStyles()

    return (
        <div className={cx(classes.buttonContainer, className)}>
            <div
                data-testid={`button-${label}`}
                className={cx(classNameLabel, {
                    [classes.buttonPrimary]: !secondary,
                    [classes.buttonSecondary]: secondary,
                    [classes.button]: true,
                    [classes.buttonDisabledPrimary]: disabled && !secondary,
                    [classes.buttonDisabledSecondary]: disabled && secondary,
                    [classes.buttonLoading]: saving,
                    [classes.buttonAlert]: alert,
                })}
                onMouseDown={disabled || saving ? noop : onClick}
            >
                {saving && (
                    <>
                        <CircularProgress
                            size={16}
                            color="inherit"
                        />
                        &nbsp;
                    </>
                )}
                {icon}
                &nbsp;
                <div className={cx(
                    isUpperCase && classes.buttonTitleUppercase,
                    classes.buttonTitle,
                )}
                >
                    {label}
                </div>
            </div>
        </div>

    )
}

Button.defaultProps = defaultProps

export default Button
